import { render, staticRenderFns } from "./large-text.vue?vue&type=template&id=01ca019e&functional=true&"
import script from "./large-text.vue?vue&type=script&lang=js&"
export * from "./large-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports